import { Grid, Group, Text } from "@mantine/core";

import { UNIT_OF_MEASUREMENT_OPTIONS_SHORT } from "../../../../../common/Constants";
import {
  cuttingLengthsToComboBoxData,
  humidityLevelToComboBoxData,
  woodTypesToComboBoxData,
} from "../../../../../common/mantine/ComboboxUtils";
import { DecimalScale2Input } from "../../../../../components/input/number/DecimalScale2Input";
import { SegmentedControlInput } from "../../../../../components/input/SegmentControll/SegmentedControlInput";
import { useOrderItems } from "../contexts/FormContexts";
import { buildWoodItemKey } from "../utils/formKeyBuilder";

import { CalculatedWoodPrice } from "./CalculatedWoodPrice";

interface OrderItemWoodProps {
  index: number;
}

export function OrderItemWood({ index }: OrderItemWoodProps) {
  const {
    form,
    contextData: {
      wood: { woodTypes, cuttingLengths, humidityLevels },
    },
  } = useOrderItems();

  const parseId = (value: string) => {
    const id = Number(value);
    return Number.isFinite(id) ? id : undefined;
  };

  return (
    <Grid align="end">
      <Grid.Col span={12}>
        <SegmentedControlInput
          data={woodTypesToComboBoxData(woodTypes)}
          data-testid="order-item-wood-type"
          form={form}
          formKey={buildWoodItemKey(index, "woodTypeId")}
          fullWidth
          parseValue={parseId}
        />
      </Grid.Col>
      <Grid.Col span={12}>
        <SegmentedControlInput
          data={cuttingLengthsToComboBoxData(cuttingLengths)}
          data-testid="order-item-wood-cutting-length"
          form={form}
          formKey={buildWoodItemKey(index, "cuttingLengthId")}
          fullWidth
          parseValue={parseId}
        />
      </Grid.Col>
      <Grid.Col span={12}>
        <SegmentedControlInput
          data={humidityLevelToComboBoxData(humidityLevels)}
          data-testid="order-item-wood-humidity-level"
          form={form}
          formKey={buildWoodItemKey(index, "humidityLevelId")}
          fullWidth
          parseValue={parseId}
        />
      </Grid.Col>
      <Grid.Col span={12}>
        <DecimalScale2Input
          {...form.getInputProps(buildWoodItemKey(index, "volume"))}
          data-testid="order-item-wood-volume"
          inputContainer={(children) => (
            <Group align="flex-start" grow wrap="nowrap">
              {children}
              <SegmentedControlInput
                data={UNIT_OF_MEASUREMENT_OPTIONS_SHORT}
                data-testid="order-item-wood-unit-of-measurement"
                form={form}
                formKey={buildWoodItemKey(index, "unitOfMeasurement")}
              />
            </Group>
          )}
          label="Volumen"
          pb={2}
          required
          rightSection={
            <Text mr={5} size="sm" variant="dimmed">
              m³
            </Text>
          }
          styles={{ input: { textAlign: "center" } }}
        />
      </Grid.Col>
      <Grid.Col span={7}>
        <CalculatedWoodPrice
          cuttingLengthId={form.getValues().itemsWood[index]?.cuttingLengthId}
          formKey={buildWoodItemKey(index, "price")}
          humidityLevelId={form.getValues().itemsWood[index]?.humidityLevelId}
          usePreset={form.getValues().itemsWood[index]?.orderItemId !== undefined}
          volume={form.getValues().itemsWood[index]?.volume}
          woodTypeId={form.getValues().itemsWood[index]?.woodTypeId}
        />
      </Grid.Col>
      <Grid.Col span={5}>
        <DecimalScale2Input
          {...form.getInputProps(buildWoodItemKey(index, "priceOverride"))}
          data-testid="order-item-wood-price-override"
          description="Preis überschreiben"
          label="Angebot"
          rightSection={
            <Text mr={5} size="sm" variant="dimmed">
              €
            </Text>
          }
          styles={{ input: { textAlign: "center" } }}
        />
      </Grid.Col>
    </Grid>
  );
}
